import { Toaster as HotToaster, ToastBar, toast } from 'react-hot-toast'
import { Box, IconButton, useTheme, alpha } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { ToastProps } from './Toast.types'

export const Toaster = ({ options }: ToastProps) => {
  const theme = useTheme()

  return (
    <HotToaster
      toastOptions={{
        duration: 5000,
        position: 'bottom-left',
        style: {
          color: theme.palette.info.dark,
          backgroundColor: alpha(theme.palette.info.main, 0.9),
          borderRadius: '4px',
          borderLeft: `2px solid ${theme.palette.info.main}`,
        },
        success: {
          duration: 5000,
          icon: (
            <CheckCircleOutlineIcon
              sx={{
                fontSize: '20px',
                color: theme.palette.success.main,
              }}
            />
          ),
          position: 'bottom-left',
          style: {
            color: theme.palette.success.dark,
            backgroundColor: 'FFFFFF',
            borderRadius: '4px',
            borderLeft: `2px solid ${theme.palette.success.main}`,
          },
        },
        error: {
          duration: Infinity,
          icon: (
            <ErrorOutlineIcon
              sx={{
                fontSize: '20px',
                color: theme.palette.error.main,
              }}
            />
          ),
          position: 'bottom-left',
          style: {
            color: theme.palette.error.dark,
            backgroundColor: 'FFFFFF',
            borderRadius: '4px',
            borderLeft: `2px solid ${theme.palette.error.main}`,
          },
        },
        ...options,
      }}
    >
      {(t) => (
        <ToastBar toast={t} style={{ maxWidth: '420px', minHeight: '64px' }}>
          {({ icon, message }) => (
            <>
              {icon}
              <Box sx={{ marginRight: '16px', fontSize: '16px' }}>
                {message}
              </Box>
              {t.type !== 'loading' && (
                <IconButton
                  onClick={() => toast.dismiss(t.id)}
                  size="small"
                  sx={{ padding: '0px' }}
                >
                  <CloseIcon sx={{ fontSize: '12px' }} />
                </IconButton>
              )}
            </>
          )}
        </ToastBar>
      )}
    </HotToaster>
  )
}
